// Support hours are whole hours, UK time. 9 -> "9am", 22 -> "10pm", 0 or 24 -> "midnight" (24-hour "09:00" in Chinese).
export const hourLabel = (h, zh = false) => {
    const n = Number(h);
    if (zh) return String(n % 24).padStart(2, '0') + ':00';
    if (n === 0 || n === 24) return 'midnight';
    if (n === 12) return '12pm';
    return n < 12 ? n + 'am' : (n - 12) + 'pm';
};
